import { Component, HostListener, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';

import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { createClaimsTable } from '@app/utils/claim-utils';
import { AlertService } from '@app/modules/alert';
import { AzureUser } from '@app-models/azure-user'
import { getCurrentUserFromStorage } from "@app/utils/storage-utils";
import { GlobalService } from '@app/services/global.services';
import { environment } from 'environments/environment';
import { OrgDataService } from '@app/services/org-data.service';
import { SoModalService } from '@app/shared';
import { GlobalConstants } from '@app/utils/global-constants';


@Component({
    selector: 'so-snapshot',
    templateUrl: './snapshot.component.html',
    styleUrls: ['./snapshot.component.scss']
})
export class SnapshotComponent  {
    constructor(protected soModalService: SoModalService) { }

}